module.exports = __webpack_public_path__ + "img/clean-edit-plotting.0adc73e0.svg";